import { useRef } from 'react';

import classNames from 'classnames';

import { useVwToPx } from '../../../../hooks/useVwToPx';

import classes from './MetaGameRewardComponent.module.scss';

type MetaGameRewardComponentProps = {
  amount: number;
  fontSize?: number;
  currencySymbol: string;
  className?: string;
};

const MetaGameRewardComponent = ({
  amount,
  currencySymbol,
  className,
  fontSize: propFontSize,
}: MetaGameRewardComponentProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const calculatedFontSize = useVwToPx({ ref, vwValue: 19 });
  const fontSize = propFontSize || calculatedFontSize;

  return (
    <div ref={ref} className={classNames(classes.giftMetaGameReward, className)} style={{ fontSize }}>
      <img className={classes.image} src={currencySymbol} />
      <span className={classes.amount} style={{ fontSize }}>
        {amount}
      </span>
    </div>
  );
};

export default MetaGameRewardComponent;
